



























































































































import Vue from 'vue';
import {
  genPostReq
} from "@/services/checklist.service";

import dropzone from 'vue2-dropzone';
import "vue2-dropzone/dist/vue2Dropzone.min.css";

export default {
  data() {
    return {
      na1: false,
      initLoaded: true, 
      search: null, 
      export_dialog: false,
      modal_title: "Import läuft...",
      checklistEntry: null, 
      headers: [
          { text: 'Typ',  value: 'type', sortable: false },
          { text: 'Name (de)',  value: 'name', sortable: false }, //JZ TODO
          { text: 'Name (en)',  value: 'name_en', sortable: false },
          { text: 'Anleitung o. Ergebnis',  value: '', sortable: false },
          { text: '',  value: '', sortable: false },
          { text: 'Bericht o. Maßnahme',  value: '', sortable: false },
          { text: '',  value: '', sortable: false },
      ],
      dropzoneOptions2: {
        url: Vue.prototype.$apiBase+"/inspect-app/import-csv",
        //headers:{   "x-access-token":localStorage.getItem('token') },   
        addRemoveLinks: false,
        params: {'cat' : 'csv'},
        acceptedFiles: ".csv",
        dictDefaultMessage: `<p class='text-default'><i class='fa fa-cloud-upload mr-2'></i> CSV Datei hochladen oder hier hin ziehem</p>
          `
      },
      list: [],
      importSteps: 10, 
      importFrom: 0,
      importTo: 0,
      importSuccess: false, 
      importCount: 0, 
      importNotFound: [],
    };
  },
  components: {
        vueDropzone: dropzone
  },

  mounted() {
    this.$store.state.headerTitle = "CSV Import Text"

    this.importSuccess = false

    genPostReq('inspect-app', 'checklist-name', { uid: this.$route.params.uid }) 
      .then(resp => {
        if (resp.data) {
          this.$store.state.headerTitle = "CSV Import Text: "+resp.data.name
        }
      })
      .catch(e => {
        this.$store.dispatch("api_error", e);
    }); 


  },
  computed: {
    checklists() {
      return null; 
    }
  },
  methods: {
    importChecklist() {
        this.export_dialog = true
        this.importFrom = 0; 
        this.importTo = this.importFrom+this.importSteps
        this.importCount = 0
        this.importNotFound = []
        this.importItems()
    },
    importItems() {
        this.importTo = this.importFrom+this.importSteps

        if (this.importTo > this.list.length) {
          this.importTo = this.list.length
        }

        let listImport = []

        if (this.importFrom >= this.importTo ) {
          console.log("FERTIG", this.importNotFound)

          this.export_dialog = false
          this.importSuccess = true
          return 
        }

        for (var i=this.importFrom ; i<=this.importTo-1 ; i++) {
          listImport.push(this.list[i])
        }

        this.importFrom = this.importTo


        genPostReq('inspect-app', 'import-entries', { uid: this.$route.params.uid, list: listImport }) 
          .then(resp => {
            if (resp.data) {
              console.log(resp.data) 
              if (resp.data.notFound) {
                this.importNotFound = [...this.importNotFound, ...resp.data.notFound]
              }

              this.importCount += resp.data.c
              this.importItems()
            }
          })
          .catch(e => {
            this.$store.dispatch("api_error", e);
        }); 

    },
    async afterSuccess(file, response) {

      let results = response.data.results
      this.importSuccess = false


      console.log(results)


     
      this.list = []

      for (var k=0 ; k<results.length ; k++) {

        
         let col1 = results[k]["Uid"].split("-")

         
          let entry = {  }

         
          if (col1[0] == 'comp') { 
              entry["type"] = "_Komponente" 

              if (results[k]["Komponente"].length > 2) {
                entry["name"] = results[k]["Komponente"]
                entry["name_en"] = results[k]["Komponente EN"]
              }
              if (results[k]["Komponente 2"].length > 2) {
                entry["name"] = results[k]["Komponente 2"]
                entry["name_en"] = results[k]["Komponente 2 EN"]
              }
              if (results[k]["Komponente 3"].length > 2) {
                entry["name"] = results[k]["Komponente 3"]
                entry["name_en"] = results[k]["Komponente 3 EN"]
              }
              if (results[k]["Komponente 4"].length > 2) {
                entry["name"] = results[k]["Komponente 4"]
                entry["name_en"] = results[k]["Komponente 4 EN"]
              }
              if (results[k]["Komponente 5"].length > 2) {
                entry["name"] = results[k]["Komponente 5"]
                entry["name_en"] = results[k]["Komponente 5 EN"]
              }
              if (results[k]["Komponente 6"].length > 2) {
                entry["name"] = results[k]["Komponente 6"]
                entry["name_en"] = results[k]["Komponente 6 EN"]
              }
          }

          if (col1[0] == 'task') { 
              entry["type"] = "__Aufgabe" 
              entry["name"] = results[k]["Aufgabe"]
              entry["name_en"] = results[k]["Aufgabe EN"]

              entry["instruction"] = results[k]["Anleitung"]
              entry["instruction_en"] = results[k]["Anleitung EN"]
              entry["reportText"] = results[k]["Bericht"]
              entry["reportText_en"] = results[k]["Bericht EN"]
          }
         
          if (col1[0] == 'question') { 
              entry["type"] = "__Prüfpunkt" 
              entry["name"] = results[k]["Prüfpunkt"]
              entry["name_en"] = results[k]["Prüfpunkt EN"]
          }
          if (col1[0] == 'option') { 
              entry["type"] = "___Prüfergebnis" 
              entry["name"] = results[k]["Prüfergebnis"]
              entry["name_en"] = results[k]["Prüfergebnis EN"]

              entry["result"] = results[k]["Ergebnis"]
              entry["result_en"] = results[k]["Ergebnis EN"]
              entry["recommendation"] = results[k]["Maßnahme"]
              entry["recommendation_en"] = results[k]["Maßnahme EN"]
          }

          entry["uid"] = results[k]["Uid"]
          entry["cat"] = col1[0]
          entry["uid_1"] = col1[1]

          if (col1.length > 2) {
            entry["uid_2"] = col1[2]
          }


      
         // console.log(results[k])
         this.list.push( entry )
         
      }

    },
    async afterComplete(upload) {
      //var imageName = uuid.v1();
      this.isLoading = true;
      try {
        //save image
        //let file = upload;
        //console.log(file)
       
        //var storageRef = firebase.storage().ref();
        //var imageRef = storageRef.child(`images/${imageName}.png`);
        //await imageRef.put(file, metadata);
        //var downloadURL = await imageRef.getDownloadURL();
        //this.images.push({ src: downloadURL });
      } catch (error) {
        console.log(error);
      }
      this.$refs.imgDropZone2.removeFile(upload);
    }   
  }
};
